module.exports = __webpack_public_path__ + "static/media/logoosgeo_small@3x.72a6d39d.jpg";